// import React, { useState } from "react";


// import {
//   Grid,
//   Box,
//   Stack,
//   Button,
//   Divider,
//   Typography,
// } from "@mui/material";

// import moment from "moment";
// import Iconify from '../components/iconify';
//  // import OpenInNewIcon from "@mui/icons-material/OpenInNew";

// export default function DocumentManager() {
//   // ---------- Dummy Data ----------
//   const dummyResumeArr = [
//     {
//       resumeUrl: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
//       createdAt: new Date(),
//       _id: "1",
//     },
//     {
//       resumeUrl: "https://www.africau.edu/images/default/sample.pdf",
//       createdAt: new Date(),
//       _id: "2",
//     },
//   ];

//   const [resumeArry] = useState(dummyResumeArr);
//   const [resumeUrl, setResumeUrl] = useState(dummyResumeArr[0].resumeUrl); 
//   const suru = 'https://docs.google.com/viewer?url=';
//   const lll = '&embedded=true';

//   return (
//     <Grid sx={{ display: "flex", flexDirection: { xs: "column", lg: "row" } }}>
      
//       {/* LEFT SIDE — RESUME VIEWER */}
//       <Box sx={{ width: { xs: "100%", lg: "50%" }, p: 1 }}>
//         <Stack
//           sx={{
//             border: 2,
//             borderColor: "text.secondary",
//             borderRadius: 1,
//           }}
//         >
//           <iframe
//             title="resume"
//             src={resumeUrl}
//             allow="clipboard-read; clipboard-write"
//             width="100%"
//             height="650px"
//             frameBorder="0"
//           />
//         </Stack>

//         <Divider sx={{ mt: 2 }} />
//       </Box>

//       {/* RIGHT SIDE — LIST + UPLOAD */}
//       <Box sx={{ width: { xs: "100%", lg: "50%" }, ml: { lg: 1 }, mt: { xs: 2, lg: 0 } }}>
//            <Typography sx={{ ml: 0.5, mb: 0.5, fontSize: '0.9rem', fontWeight: '600' }}>Documents</Typography>
//         <Stack
//           sx={{
//             backgroundColor: "text.background",
//             borderRadius: 2,
//             boxShadow: 3,
//             p: 2,
//             gap: 2,
//           }}
//         >
//           {/* ADD NEW BUTTON */}
//           <Stack sx={{ flexDirection: "row", gap: 1 }}>
//             <Stack>
//               <Button variant="contained" size="small" color="primary">
//                 Add New
//               </Button>

//               <input
//                 style={{ opacity: 0, position: "absolute", width: 120 }}
//                 type="file"
//                 accept=".doc,.docx,application/pdf"
//               />
//             </Stack>
//           </Stack>

//           {/* SCROLL AREA */}
//           <Box sx={{ maxHeight: 300, overflowY: "auto", pr: 1 }}>
//             {resumeArry.map((item, index) => (
//               <Stack
//                 key={item._id}
//                 sx={{
//                   flexDirection: "row",
//                   justifyContent: "space-between",
//                   mb: 1,
//                 }}
//               >
//                 {/* LEFT: Name + Open */}
//                 <Stack sx={{ flexDirection: "row", alignItems: "center" }}>
//                   <Typography
//                     color={"text.secondary"}
//                     sx={{ textDecoration: "underline", cursor: "pointer" }}
//                     onClick={() => setResumeUrl(item.resumeUrl)}
//                   >
//                     Resume #{index + 1}
//                   </Typography>

//                  <Iconify
//                                              icon="mdi:open-in-new"
//                                              fontSize={20}
//                                              sx={{ cursor: 'pointer', ml: 3 }}
//                                              onClick={() => window.open(suru + item.resumeUrl + lll, '_blank')}
//                                              color={'text.secondary'}
//                                            />
//                 </Stack>

//                 {/* DATE */}
//                <Typography sx={{}}>Uploaded on : {moment(item.createdAt).format('ll')}</Typography>

//                 {/* RIGHT: Delete + Download */}
//                <Stack sx={{ flexDirection: 'row' }}>
//                                         {/* <Typography color={'text.secondary'} sx={{ cursor: 'pointer' }} onClick={() => resumeDelete(item._id)}> */}
//                                         <Typography
//                                           color={'text.secondary'}
//                                           sx={{ cursor: 'pointer' }}
//                                         //  onClick={() => handleOpenDeleteModal(item._id)}
//                                         >
//                                           Delete
//                                         </Typography>
//                                         <Typography
//                                           color={'text.secondary'}
//                                           sx={{ cursor: 'pointer', ml: 3 }}
//                                           onClick={() => window.open(item.resumeUrl, '_blank')}
//                                         >
//                                           Download
//                                         </Typography>
//                                       </Stack>
//               </Stack>
//             ))}
//           </Box>
//         </Stack>
//       </Box>
//     </Grid>
//   );
// }







// import React, { useState } from "react";

// import {
//   Grid,
//   Box,
//   Stack,
//   Button,
//   Divider,
//   Typography,
//   Modal
// } from "@mui/material";

// import moment from "moment";
// import { useLocation } from "react-router-dom";
// import Iconify from '../components/iconify';


// export default function DocumentManager() { 
//   // ---------- Dummy Data ----------
//   const dummyResumeArr = [
//     {
//       resumeUrl: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
//       createdAt: new Date(),
//       _id: "1",
//     },
//     {
//       resumeUrl: "https://www.africau.edu/images/default/sample.pdf",
//       createdAt: new Date(),
//       _id: "2",
//     },
//   ];

//   const [resumeArry] = useState(dummyResumeArr);
//   const [resumeUrl, setResumeUrl] = useState(dummyResumeArr[0].resumeUrl);

//   // NEW STATES FOR MODAL
//   const [open, setOpen] = useState(false);
//   const [docTitle, setDocTitle] = useState("");
//   const [selectedFile, setSelectedFile] = useState(null);

//   const suru = 'https://docs.google.com/viewer?url=';
//   const lll = '&embedded=true';



//   const location = useLocation();

//   const { id, type } = location.state || {};  






//   return (
//     <Grid sx={{ display: "flex", flexDirection: { xs: "column", lg: "row" } }}>

//       {/* LEFT SIDE — RESUME VIEWER */}
//       <Box sx={{ width: { xs: "100%", lg: "50%" }, p: 1 }}>
//         <Stack
//           sx={{
//             border: 2,
//             borderColor: "text.secondary",
//             borderRadius: 1,
//           }}
//         >
//           <iframe
//             title="resume"
//             src={resumeUrl}
//             allow="clipboard-read; clipboard-write"
//             width="100%"
//             height="650px"
//             frameBorder="0"
//           />
//         </Stack>

//         <Divider sx={{ mt: 2 }} />
//       </Box>

//       {/* RIGHT SIDE — LIST + UPLOAD */}
//       <Box sx={{ width: { xs: "100%", lg: "50%" }, ml: { lg: 1 }, mt: { xs: 2, lg: 0 } }}>
//         <Typography sx={{ ml: 0.5, mb: 0.5, fontSize: '0.9rem', fontWeight: '600' }}>Documents</Typography>

//         <Stack
//           sx={{
//             backgroundColor: "text.background",
//             borderRadius: 2,
//             boxShadow: 3,
//             p: 2,
//             gap: 2,
//           }}
//         >

//           {/* ADD NEW BUTTON */}
//           <Stack sx={{ flexDirection: "row", gap: 1 }}>
//             <Button variant="contained" size="small" sx={{color:"#ffff",backgroundColor: "#3C6BA5"} }onClick={() => setOpen(true)}>
//               Add New
//             </Button>
//           </Stack>

//           {/* SCROLL AREA */}
//           <Box sx={{ maxHeight: 300, overflowY: "auto", pr: 1 }}>
//             {resumeArry.map((item, index) => (
//               <Stack
//                 key={item._id}
//                 sx={{
//                   flexDirection: "row",
//                   justifyContent: "space-between",
//                   mb: 1,
//                 }}
//               >
//                 {/* LEFT: Name + Open */}
//                 <Stack sx={{ flexDirection: "row", alignItems: "center" }}>
//                   <Typography
//                     color={"text.secondary"}
//                     sx={{ textDecoration: "underline", cursor: "pointer" }}
//                     onClick={() => setResumeUrl(item.resumeUrl)}
//                   >
//                     Resume #{index + 1}
//                   </Typography>

//                   <Iconify
//                     icon="mdi:open-in-new"
//                     fontSize={20}
//                     sx={{ cursor: 'pointer', ml: 3 }}
//                     onClick={() => window.open(suru + item.resumeUrl + lll, '_blank')}
//                     color={'text.secondary'}
//                   />
//                 </Stack>

//                 {/* DATE */}
//                 <Typography>Uploaded on : {moment(item.createdAt).format('ll')}</Typography>

//                 {/* RIGHT: Delete + Download */}
//                 <Stack sx={{ flexDirection: 'row' }}>
//                   <Typography
//                     color={'text.secondary'}
//                     sx={{ cursor: 'pointer' }}
//                   >
//                     Delete
//                   </Typography>

//                   <Typography
//                     color={'text.secondary'}
//                     sx={{ cursor: 'pointer', ml: 3 }}
//                     onClick={() => window.open(item.resumeUrl, '_blank')}
//                   >
//                     Download
//                   </Typography>
//                 </Stack>
//               </Stack>
//             ))}
//           </Box>
//         </Stack>
//       </Box>

//       {/* ===================== MODAL START ===================== */}
//       <Modal open={open} onClose={() => setOpen(false)}>
//         <Box
//           sx={{
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//             width: 380,
//             bgcolor: "background.paper",
//             boxShadow: 24,
//             p: 3,
//             borderRadius: 2
//           }}
//         >
//           <Typography variant="h6" sx={{ mb: 2 }}>
//             Upload Document
//           </Typography>

//           {/* Document Title */}
//           <Typography sx={{ fontSize: "0.9rem", mb: 0.5 }}>Document Title</Typography>

//           <input
//             type="text"
//             placeholder="Enter document name"
//             value={docTitle}
//             onChange={(e) => setDocTitle(e.target.value)}
//             style={{
//               width: "100%",
//               padding: "10px",
//               borderRadius: 6,
//               border: "1px solid #999",
//               marginBottom: "15px"
//             }}
//           />

//           {/* File Select */}
//           <Typography sx={{ fontSize: "0.9rem", mb: 0.5 }}>Choose File</Typography>

//           <input
//             type="file"
//             accept=".pdf,.doc,.docx"
//             onChange={(e) => setSelectedFile(e.target.files[0])}
//             style={{ marginBottom: "20px" }}
//           />

//           {/* Upload Button */}
//           <Button
//             variant="contained"
//             fullWidth
//             disabled={!docTitle || !selectedFile}
//             onClick={() => {
//               setOpen(false);
//             }}
//           >
//             Upload
//           </Button>
//         </Box>
//       </Modal>
//       {/* ===================== MODAL END ===================== */}

//     </Grid>
//   );
// }
import React, { useEffect, useState } from "react";

import {
  Grid,
  Box,
  Stack,
  Button,
  Divider,
  Typography,
  Modal
} from "@mui/material";


import { ToastContainer, toast } from 'react-toastify';
import moment from "moment";
import { useLocation ,useNavigate} from "react-router-dom";
import Iconify from '../components/iconify';
import { Api, UploadFile } from "../webservices";  


 

import 'react-toastify/dist/ReactToastify.css';

export default function DocumentManager() { 

   const navigate = useNavigate();

  const [resumeArry, setResumeArry] = useState([]);


  // MODAL STATES
  const [open, setOpen] = useState(false);
  const [docTitle, setDocTitle] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);  




const [openDelete, setOpenDelete] = useState(false);
const [fileId1, setFileId] = useState("");


  

  const suru = 'https://docs.google.com/viewer?url=';
  const lll = '&embedded=true';

  const location = useLocation();
  const { id, type } = location.state || {};

  console.log("heelohbv", type);

    const [resumeUrl, setResumeUrl] = useState("");


 const fetchPlacementFiles = async () => {
    try {
      const token = localStorage.getItem("token");

      const body = {
        placementId: id
      };

      const res = await Api(`resume/placement/files`, "POST", body, token);

      
 
      if (res.status === 200 && res.data.status === 200) {
              setResumeArry(res.data.files);  

           if(res.data.files.length > 0) {
                 setResumeUrl(res.data.files[0].fileUrl); 
           }

      } else {
        toast.error(res.data.message);
      }

    } catch (error) {
      console.log(error);
      toast.error("Something went wrong");
    }
  };
useEffect(() => {
  fetchPlacementFiles();
}, []); 


const getDetails = (id) => {
  const body = {
    resumeId: id
  };

  const token = localStorage.getItem("token");

  Api(`resume/getResumeDetail`, 'POST', body, token)
    .then((response) => {
      console.log("sharmatlevel==>", response);
      // if (response.status === 200) {
      //   if (response.data.status === 200) {
             
      //     console.log("Success:hello sharma ji pathan", response.data);
      //   } else {
      //     toast.warn(response.data.message + '!');
      //   }
      // } else {
      //   toast.warn(response.data.message + '!');
      // }
    })
    .catch((err) => {
      toast.error(err);
    });
};




const getBenchDetail = (benchId) => {
  const body = { benchId };
  const token = localStorage.getItem("token");

  return Api(`bench/getBenchDetail`, 'POST', body, token)
    .then((response) => {
      console.log("Bench Detail Response ==>", response);

      if (response.status === 200) {
        if (response.data.status === 200) {
          console.log("Bench Detail Success:", response.data);
        } else {
          toast.warn(`${response.data.message}!`);
        }
      } else {
        toast.warn(`${response.data.message}!`);
      }
    })
    .catch((err) => {
      toast.error(`${err}`);
    });
};












  // -------------------- FILE UPLOAD FUNCTION --------------------
  const uploadMulti = (file) => {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem("token");
      const formData = new FormData();

      formData.append("document", file);
      formData.append("directoryName", "resume");

      UploadFile(`resume/upload_resume`, formData, token)
        .then((res) => {
          if (res.status === 200 && res.data.code === 200) {
            resolve(res.data.filePath); // URL return
          } else {
               reject(Response.data.message || "Upload failed");

          }
        })
        .catch((err) => reject(err));
    });
  };

  // -------------------- FINAL API CALL --------------------
  const uploadPlacementDoc = async () => {
    if (!docTitle || !selectedFile) return;

    const token = localStorage.getItem("token");

    try {

      const fileUrl1 = await uploadMulti(selectedFile);  

      
      const body = {
  placementId:id,
  fileUrl:fileUrl1,
  "type": type==="rec" ? "resume" : "bench",
  fileName:docTitle
};


      // STEP 3: Api() call/uploadPlacementDoc
      Api(`resume/uploadPlacementDoc`, "POST", body, token)
        .then((response) => {
           console.log("hello logo ====>", response );
          if (response.status === 200 && response.data.status === 200){
            toast.success(response.data.message)
            setOpen(false);
            setDocTitle("");
            setSelectedFile(null); 
            fetchPlacementFiles();

          } else {
            toast.error(response.data.message);
             setOpen(false);
            setDocTitle("");
            setSelectedFile(null); 

          }
        })
        .catch((err) => {
          console.log(err);
          alert("Something went wrong");
        });

    } catch (err) {
      console.log(err);
      alert("Upload failed");
    }
  };



  const handleDeleteFile = async () => {
  try {
    const token = localStorage.getItem("token");

    const body = {
      placementId: id,  
      fileId: fileId1             
    };

    const res = await Api(`resume/deletePlacementFile`, "POST", body, token);

    if (res.status === 200 && res.data.status === 200) {
      toast.success(res.data.message);
      setOpenDelete(false);
      fetchPlacementFiles();   
    } else {
      toast.error(res.data.message);
    }

  } catch (error) {
    console.log(error);
    toast.error("Something went wrong");
  }
};


  return (

    <>
    <ToastContainer />

     <Stack sx={{ flexDirection: 'row', p: 1, justifyContent: 'space-between' }}>
         <Stack sx={{ flexDirection: 'row' }}>
           <Iconify
             icon="ion:arrow-back"
             fontSize={25}
             sx={{ cursor: 'pointer', color: 'text.secondary', fontSize: '0.9rem', fontWeight: '600', mr: 1 }}
             onClick={() => navigate("/placement")}
           />
 
           <Typography
             color={'text.secondary'}
             style={{ textDecoration: 'underline', cursor: 'pointer', fontSize: '0.9rem', fontWeight: '600' }}
             onClick={() => navigate("/placement")}
           >
             Placements
           </Typography>
           <Iconify
             icon="ic:round-greater-than"
             sx={{ color: 'text.secondary', fontSize: '0.9rem', fontWeight: '600' }}
           />
           <Typography
             color={'text.textG'}
             sx={{ mx: 1, fontSize: '0.9rem', fontWeight: '600', textTransform: 'capitalize' }}
           >
             { type==="rec" ? "recruiter" : "bench"}
           </Typography>
           <Iconify
             icon="ic:round-greater-than"
             sx={{ color: 'text.textG', fontSize: '0.9rem', fontWeight: '600', textTransform: 'capitalize' }}
           />
           <Typography
             color={'text.textG'}
             sx={{ mx: 1, fontSize: '0.9rem', fontWeight: '600', textTransform: 'capitalize' }}
           >
             {/* {row?.status} */}Documents
           </Typography>
         </Stack>
 
 
 
 
 
 
{/*  
         <Button variant="contained" size="small" color="custom" onClick={() => window.open(resumeUrl, '_blank')}>
           Download
         </Button> */}
       </Stack>






      <Grid sx={{ display: "flex", flexDirection: { xs: "column", lg: "row" } }}>
      {/* LEFT SIDE — RESUME VIEWER */}
      <Box sx={{ width: { xs: "100%", lg: "50%" }, p: 1 }}>
        <Stack
          sx={{
            border: 2,
            borderColor: "text.secondary",
            borderRadius: 1,
          }}
        >
          <iframe
            title="resume"
      
           src={suru + (resumeUrl) + lll}
            allow="clipboard-read; clipboard-write"
            width="100%"
            height="650px"
            frameBorder="0"
          />
        </Stack>

        <Divider sx={{ mt: 2 }} />
      </Box>

      {/* RIGHT SIDE */}
      <Box sx={{ width: { xs: "100%", lg: "50%" }, ml: { lg: 1 }, mt: { xs: 2, lg: 0 } }}>
        <Typography sx={{ ml: 0.5, mb: 0.5, fontSize: '0.9rem', fontWeight: '600' }}>Documents</Typography>

        <Stack
          sx={{
            backgroundColor: "text.background",
            borderRadius: 2,
            boxShadow: 3,
            p: 2,
            gap: 2,
          }}
        >

          {/* ADD NEW BUTTON */}
          <Stack sx={{ flexDirection: "row", gap: 1 }}>
            <Button
              variant="contained"
              size="small"
              sx={{ color: "#fff", backgroundColor: "#3C6BA5" }}
              onClick={() => setOpen(true)}
            >
              Add New
            </Button>
          </Stack>

          {/* DOCUMENT LIST */}
          <Box sx={{ maxHeight: 300, overflowY: "auto", pr: 1 }}>
            {resumeArry.map((item, index) => (
              <Stack
                key={item._id}
                sx={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  mb: 1,
                }}
              >
                <Stack sx={{ flexDirection: "row", alignItems: "center" }}>
                  <Typography
                    color={"text.secondary"}
                    sx={{ textDecoration: "underline", cursor: "pointer" }}
                    onClick={() => setResumeUrl(item.fileUrl)}
                  >
                    {item.fileName}
                  </Typography>

                  <Iconify
                    icon="mdi:open-in-new"
                    fontSize={20}
                    sx={{ cursor: 'pointer', ml: 3 }}
                    onClick={() => window.open(suru + item.fileUrl + lll, '_blank')}
                    color={'text.secondary'}
                  />
                </Stack>

                <Typography>Uploaded on: {moment(item.createdAt).format('ll')}</Typography>

                <Stack sx={{ flexDirection: 'row' }}>
                  <Typography color={'text.secondary'} sx={{ cursor: 'pointer' }} onClick={() => {
                  setFileId(item._id);   
                  setOpenDelete(true);   
                      }}>
                    Delete
                  </Typography>

                  <Typography
                    color={'text.secondary'}
                    sx={{ cursor: 'pointer', ml: 3 }}
                    onClick={() => window.open(item.fileUrl, '_blank')}
                  >
                    Download
                  </Typography>
                </Stack>
              </Stack>
            ))}
          </Box>
        </Stack> 
      </Box>

      {/* ===================== MODAL START ===================== */}

      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 380,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 3,
            borderRadius: 2
          }}
        >
          <Typography variant="h6" sx={{ mb: 2 }}>
            Upload Document
          </Typography>

          <Typography sx={{ fontSize: "0.9rem", mb: 0.5 }}>Document Title</Typography>

          <input
            type="text"
            placeholder="Enter document name"
            value={docTitle}
            onChange={(e) => setDocTitle(e.target.value)}
            style={{
              width: "100%",
              padding: "10px",
              borderRadius: 6,
              border: "1px solid #3C6BA5",
              marginBottom: "15px",
              color: "#000",          
    fontWeight: "500",      
    opacity: 1, 
            }}
          />

          <Typography sx={{ fontSize: "0.9rem", mb: 0.5 }}>Choose File</Typography>

          <input
            type="file"
            accept=".pdf,.doc,.docx"
            onChange={(e) => setSelectedFile(e.target.files[0])} 
            style={{ marginBottom: "20px" }}
          />

          {/* <Button
            variant="contained"
            fullWidth
            disabled={!docTitle || !selectedFile}
            onClick={uploadPlacementDoc}
          >
            Upload
          </Button> */}



          <Button color="custom" variant="contained" size="small" sx={{}}
                       onClick={uploadPlacementDoc}
                           disabled={!docTitle || !selectedFile}
                              fullWidth

                    >
                     Upload
                    </Button>
        </Box>
      </Modal>
     

   

       <Modal open={openDelete} onClose={() => setOpenDelete(false)}>
  <Box
    sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 350,
      bgcolor: "background.paper",
      p: 3,
      borderRadius: "10px",
      boxShadow: 24,
    }}
  >
    <Typography
      sx={{ fontSize: "18px", fontWeight: 600, textAlign: "center", mb: 2 }}
    >
      Confirm Delete
    </Typography>

    <Typography sx={{ textAlign: "center", mb: 3 }}>
      Are you sure you want to delete this file?
    </Typography>

    <Box sx={{ display: "flex", gap: 2 }}>
      <Button
        fullWidth
        variant="contained"
         sx={{ color: "#fff", backgroundColor: "#3C6BA5" }}
        onClick={() => setOpenDelete(false)}
      >
        Cancel
      </Button>

      <Button
        fullWidth
        variant="contained"
            sx={{ color: "#fff", backgroundColor: "#3C6BA5" }}
        onClick={handleDeleteFile}
      >
        Yes, Delete
      </Button>
    </Box>
  </Box>
        </Modal>



       </Grid>
    </>
   
  );
}
